/**
 * @generated SignedSource<<b7ec0f0fe086f954d53f65c8a8b10715>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ScrapbookViewQuery$variables = Record<PropertyKey, never>;
export type ScrapbookViewQuery$data = {
  readonly me: {
    readonly learner: {
      readonly defaultCharacter: {
        readonly audience: string;
      } | null | undefined;
      readonly id: string;
      readonly scrapbook: ReadonlyArray<{
        readonly character: {
          readonly accentHex: string;
          readonly artKey: string;
          readonly displayName: string;
          readonly intensity: number;
        } | null | undefined;
        readonly createdAt: any;
        readonly id: string;
        readonly sentence: string | null | undefined;
        readonly sticker: string;
        readonly turnId: string | null | undefined;
      }>;
    } | null | undefined;
  } | null | undefined;
};
export type ScrapbookViewQuery = {
  response: ScrapbookViewQuery$data;
  variables: ScrapbookViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "audience",
  "storageKey": null
},
v2 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sticker",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sentence",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "turnId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "artKey",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accentHex",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "intensity",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ScrapbookViewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Learner",
            "kind": "LinkedField",
            "name": "learner",
            "plural": false,
            "selections": [
              (v0/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Character",
                "kind": "LinkedField",
                "name": "defaultCharacter",
                "plural": false,
                "selections": [
                  (v1/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v2/*:: as any*/),
                "concreteType": "ScrapbookPage",
                "kind": "LinkedField",
                "name": "scrapbook",
                "plural": true,
                "selections": [
                  (v0/*:: as any*/),
                  (v3/*:: as any*/),
                  (v4/*:: as any*/),
                  (v5/*:: as any*/),
                  (v6/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Character",
                    "kind": "LinkedField",
                    "name": "character",
                    "plural": false,
                    "selections": [
                      (v7/*:: as any*/),
                      (v8/*:: as any*/),
                      (v9/*:: as any*/),
                      (v10/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "scrapbook(first:100)"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ScrapbookViewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Learner",
            "kind": "LinkedField",
            "name": "learner",
            "plural": false,
            "selections": [
              (v0/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Character",
                "kind": "LinkedField",
                "name": "defaultCharacter",
                "plural": false,
                "selections": [
                  (v1/*:: as any*/),
                  (v0/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v2/*:: as any*/),
                "concreteType": "ScrapbookPage",
                "kind": "LinkedField",
                "name": "scrapbook",
                "plural": true,
                "selections": [
                  (v0/*:: as any*/),
                  (v3/*:: as any*/),
                  (v4/*:: as any*/),
                  (v5/*:: as any*/),
                  (v6/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Character",
                    "kind": "LinkedField",
                    "name": "character",
                    "plural": false,
                    "selections": [
                      (v7/*:: as any*/),
                      (v8/*:: as any*/),
                      (v9/*:: as any*/),
                      (v10/*:: as any*/),
                      (v0/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "scrapbook(first:100)"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "68b28651673f754e0bf2bc4a44c0d05e",
    "id": null,
    "metadata": {},
    "name": "ScrapbookViewQuery",
    "operationKind": "query",
    "text": "query ScrapbookViewQuery {\n  me {\n    learner {\n      id\n      defaultCharacter {\n        audience\n        id\n      }\n      scrapbook(first: 100) {\n        id\n        sticker\n        createdAt\n        sentence\n        turnId\n        character {\n          displayName\n          artKey\n          accentHex\n          intensity\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c19a1028475340ca59457d38a3afd0ff";

export default node;
